export enum Roles {
    Guest = "Guest",
    Admin = "Admin"
  }